import {
  getCurrentProfileSelect,
  PROFILE_KEY
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { createSelector } from 'reselect'

const getEmailProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(profile, PROFILE_KEY.EMAIL)
)

export default getEmailProfileSelect
